////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

////    COMPONENTS    ////
import { IconModule, LoaderButtonModule } from '@helvetia/components'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'
import { MarketComponent } from './market.component'
import { FlexLayoutModule } from '@angular/flex-layout'
import { EditMarketModule } from '../edit-market/edit-market.module'
import { EditTypeSupportModule } from '../edit-type-support/edit-type-support.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

@NgModule({
  declarations: [MarketComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    IconModule,
    LoaderButtonModule,
    MaterialImporterModule,
    EditMarketModule,
    EditTypeSupportModule
  ],
  exports: [MarketComponent],
})
export class MarketModule {}
